import React, { useState, useEffect } from 'react';
import { getWeather, getBirthdaysToday } from '../api/apiClient';
import './WelcomeCard.css';

const timeGreeting = () => {
  const h = new Date().getHours();
  if (h < 12) return 'Good morning';
  if (h < 17) return 'Good afternoon';
  return 'Good evening';
};

const dateString = () => new Date().toLocaleDateString('en-US', {
  weekday: 'long', month: 'long', day: 'numeric',
});

const firstName = name => (name || '').trim().split(/\s+/)[0];

const WelcomeCard = ({ currentUser }) => {
  const [weather,    setWeather]    = useState(null);
  const [time,       setTime]       = useState(new Date());
  const [isBirthday, setIsBirthday] = useState(false);

  const office = currentUser?.office || 'Chicago';

  useEffect(() => {
    getWeather(office).then(res => setWeather(res.data)).catch(() => {});
  }, [office]);

  useEffect(() => {
    if (!currentUser?.id) return;
    getBirthdaysToday()
      .then(res => {
        const list = Array.isArray(res.data) ? res.data : [];
        setIsBirthday(list.some(p => p.id === currentUser.id));
      })
      .catch(() => {});
  }, [currentUser?.id]);

  // tick every minute so greeting updates if left open across noon/5pm
  useEffect(() => {
    const id = setInterval(() => setTime(new Date()), 60_000);
    return () => clearInterval(id);
  }, []);

  void time; // used only to trigger re-render

  const greetingText = isBirthday
    ? `Happy Birthday, ${firstName(currentUser?.name)}`
    : `${timeGreeting()}, ${firstName(currentUser?.name)}`;

  return (
    <div className="wc-card">
      <div className="wc-greeting">
        {greetingText}!
      </div>
      <div className="wc-date">{dateString()}</div>
      {weather ? (
        <>
          <div className="wc-weather">
            <span className="wc-temp">{weather.temp_f}°F</span>
            <span className="wc-sep">·</span>
            <span className="wc-text">{weather.text}</span>
            <span className="wc-sep">·</span>
            <span className="wc-location">{office}</span>
          </div>
          <div className="wc-weather-detail">
            {weather.feels_like_f != null && (
              <span>Feels like {weather.feels_like_f}°</span>
            )}
            {weather.high_f != null && (
              <span>High {weather.high_f}°</span>
            )}
            {weather.low_f != null && (
              <span>Low {weather.low_f}°</span>
            )}
            {weather.rain_pct != null && (
              <span>Rain {weather.rain_pct}%</span>
            )}
          </div>
        </>
      ) : (
        <div className="wc-weather wc-weather--loading">Loading weather…</div>
      )}
    </div>
  );
};

export default WelcomeCard;
